<template>
    <v-layout align-center justify-center>
        <v-flex xs12 sm10 md8>
            <v-card class="elevation-12">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>Mot de passe oublié</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-form autocomplete="off" @submit.prevent="changePassword">
                <v-card-text>
                    <v-alert v-model="has_success" dismissible type="warning">{{ success_message }}</v-alert>
                    <v-alert v-model="has_error" dismissible type="error">{{ error_message }}</v-alert>
                        <v-text-field prepend-icon="person" name="login" label="Identifiant" type="text" v-model="email" required></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" type="submit" v-if="!this.has_success">Changer le mot de passe</v-btn>
                        <v-btn color="secondary" v-else @click.prevent="showLoginForm">Retour</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import { mapActions } from 'vuex'
    export default {
        name: 'ForgotPassword',
        data() {
            return {
                email: null,
                has_error: false,
                has_success: false,
                success_message: String,
                error_message: String
            }
        },

        mounted() {
        },

        methods: {
            ...mapActions(["forgotPassword"]),
            changePassword() {
                this.forgotPassword({
                       email: this.email,
                    }).then(response => {
                        this.has_error = false
                        this.error_message = null
                        this.has_success = true
                        this.success_message = "Un lien pour changer votre mot de passe a été envoyé à votre adresse email."
                    }).catch(error => {
                        this.has_success = false
                        this.has_error = true
                        this.success_message = null
                        this.error_message = error.response.data.message
                    })
            },
            showLoginForm() {
                this.$router.push({name: 'login'})
            }
        }
    }
</script>

<style scoped>

</style>
